export default __webpack_public_path__ + "static/bg-jobs-b7370a31a8a53d54b76c6ff2a97520a4.jpg";